/**
 * utils/analytics.ts
 *
 * Thin wrapper around the log_user_event Supabase RPC.
 * All analytics writes from the frontend go through this module.
 * RPC errors are logged (warn) but never rethrown — analytics must never break the main flow.
 */

import { supabase } from '../lib/supabase';

export type AnalyticsEvent =
  | 'session_started'
  | 'template_created'
  | 'request_sent'
  | 'request_completed'
  | 'response_viewed';

export async function logEvent(
  eventType: AnalyticsEvent,
  metadata?: Record<string, unknown>
): Promise<void> {
  try {
    const { error } = await supabase.rpc('log_user_event', {
      p_event_type: eventType,
      p_metadata: metadata ?? null,
    });
    if (error) console.warn('logEvent RPC error:', eventType, error.message);
  } catch (err) {
    console.warn('logEvent unexpected error:', eventType, err);
  }
}
